import React from 'react';
import { Field, useFormState } from 'react-final-form';
import { useIntl } from 'react-intl';

import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import { BaseField } from './types';
import { PRODUCT_INFO_FIELD_MAX_LENGTH } from '../../../constants';
import { useProductOverridesContext } from '../../../context/ProductOverridesContext';
import { FormRowRenderer } from '../FormRowRenderer';
import { ProductInfoValue, StyledInputContainer, StyledTextarea } from '../OfferDetailsFormFields.styles';
import { AdvancedDetails, FormValues } from '../types';

export const Additives = ({ sidePanelMode, offer, menuLocalizer }: BaseField) => {
  const menuPermissions = useOfferingMenuPermissionsContext();
  const intl = useIntl();
  const { values } = useFormState<FormValues>();
  const { isAttrConnectedToProduct } = useProductOverridesContext();

  const previewComponent = <ProductInfoValue>{menuLocalizer(offer?.additives) || '-'}</ProductInfoValue>;

  const editComponent = (
    <Field<AdvancedDetails['additives']> name="additives">
      {field => (
        <StyledInputContainer characterCount={{ value: field.input.value.length, max: PRODUCT_INFO_FIELD_MAX_LENGTH }}>
          <StyledTextarea
            {...field.input}
            maxLength={PRODUCT_INFO_FIELD_MAX_LENGTH}
            placeholder={intl.formatMessage({ id: 'menu.additives-placeholder' })}
            spellCheck
            disabled={isAttrConnectedToProduct('additives')}
          />
        </StyledInputContainer>
      )}
    </Field>
  );

  return (
    <FormRowRenderer
      catalogName="additives"
      hasContentEditPermission={menuPermissions.contentEdit}
      label={intl.formatMessage({ id: 'menu.additives' })}
      previewComponent={previewComponent}
      editComponent={editComponent}
      shouldDisplayCreateTag={!values.additives}
      sidePanelMode={sidePanelMode}
      offer={offer}
    />
  );
};
